/** *****************************************************************************
 * Licensed Materials - Property of IBM
 * (c) Copyright IBM Corporation 2024. All Rights Reserved.
 *
 * Note to U.S. Government Users Restricted Rights:
 * Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 ****************************************************************************** */

// Note, overriding formatting options for eslint prettier for this file, to same as cloud-pal-community
// https://github.ibm.com/ibmcloud/cloud-pal-community/blob/41d9e5ec25db30078d6c14d5a89fcd4cc0ee63c3/prettier.config.js
/* eslint prettier/prettier: ["error", { jsxBracketSameLine: true, printWidth: 80, singleQuote: true, proseWrap: 'always', arrowParens: 'avoid', }] */

/* eslint-disable react-hooks/rules-of-hooks */
// Data Hook Generator
// import useDataHook from 'src/api-helpers';
import useDataHook from '@console/cloud-pal-community/api-helpers';

// Config file
import config from './usePartialToolConfig';

// By default we export the data hook
export default useDataHook(config);